export default __webpack_public_path__ + "static/media/srisaila.2bbf7a8c.png";